import { css, html } from "../helpers/webComponents";

const styles: string = css`
:host {
    display: flex;
    align-items: center;
    font-family: "Onesize";
    background: rgba(41, 35, 35, 0.85);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 20px;
    color: white;
    gap: 10px;
    width: 100%;
    height: 90%;
    margin-top: 12.5%;
    box-sizing: border-box;
}
input {
    font-size: 1rem;
    border-radius: 8px;
    padding: 10px 0px;
    border: none;
    width: 100%;
    margin-bottom: 20px;
}
button {
    padding: 10px;
    font-size: 1rem;
    border-radius: 8px;
    cursor: pointer;
    background: white;
    color: black;
    font-weight: bold;
    border: none;
    width: 100%;
}
`;

export class GameAccountComponent extends HTMLElement {
    private _username: string = "";

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) return;

        const element: HTMLElement = html`
            <div class="account-form">
                <style>${styles}</style>
                <input type="text" id="username" placeholder="Enter your name" />
                <button id="submitBtn">Use Username</button>
            </div>
        `;

        this.shadowRoot.innerHTML = "";
        this.shadowRoot.appendChild(element);

        const input: HTMLInputElement | null = this.shadowRoot.querySelector<HTMLInputElement>("#username");
        const button: HTMLButtonElement | null = this.shadowRoot.querySelector<HTMLButtonElement>("#submitBtn");

        input?.addEventListener("input", e => {
            this._username = (e.target as HTMLInputElement).value;
        });

        button?.addEventListener("click", () => {
            const trimmed: string = this._username.trim();
            if (trimmed) {
                try {
                    localStorage.setItem("username", trimmed);
                    localStorage.setItem("elapsed_time", "0");

                    this.dispatchEvent(new CustomEvent("username-submitted", {
                        detail: { username: trimmed },
                        bubbles: true,
                        composed: true,
                    }));

                    location.reload();
                }
                catch (error) {
                    console.error("Failed to store username or reset timer:", error);
                }
            }
        });
    }
}
